<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Faktura" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<select-view label="Kunde" v-model="entity.customer_id" :options="_customers" />
					<select-view v-show="entity.customer_id == 0" label="Kundegruppe" v-model="entity.customer_group_id" :options="_customer_groups" />
					<select-view v-show="entity.customer_id == 0" label="Moms zone" v-model="entity.vat_zone_id" :options="_vat_zones" />
				</div>
				<div v-show="active == 'details'">
					<date-select-view label="Dato" v-model="entity.date" :controller="$store.state.popupController" />
				</div>
				<div v-show="active == 'details'">
					<select-view label="Valuta" v-model="entity.currency_id" :options="_currencies" />
					<select-view label="Layout" v-model="entity.layout_id" :options="_layouts" />
					<select-view label="Betingelser" v-model="entity.terms_id" :options="_terms" />
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Opret" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import ContactSelectView from '../views/ContactSelectView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import TaskListView from '../views/TaskListView';
	import AddressView from '../views/AddressView';

	import OrderModel from '../model/Order'
	import ContactModel from '../model/Contact'

	import merge from '../functions/merge'

	// Defaults
	const economics = {
		customer_group_id: 	2,		// Flytning
		vat_zone_id: 		1,		// Domestic
		currency_id: 		'DKK',
		layout_id: 			15, 	// Bank
		terms_id: 			6, 		// Netto 3 dage
	};

	export default {
		data: function () {
			return {
				//packaging: [],
				//ORDER: [],
				entity: {
					customer_id:			null,
					customer_group_id: 		economics.customer_group_id,
					vat_zone_id:			economics.vat_zone_id,
					date: 					(new Date()).format('Y-m-d'),
					currency_id: 			economics.currency_id,
					layout_id: 				economics.layout_id,
					terms_id: 				economics.terms_id,
					recipient: 				'',
					recipient_name: 		'',
					recipient_vat_zone_id: 	null
				},
				active: 'details',
				//instructions: [],

				rawCustomers: [],
				
				customers: [],
				customer_groups: [],
				currencies: [],
				layouts: [],
				terms: [],
				vat_zones: [],



				departments: [],
				staticNumbers: [
					{
						name: 'vat',
						label: 'CVR',
						default: ''
					},
					{
						name: 'ean',
						label: 'EAN',
						default: ''
					}
				],
				numbers: [],
				status: [],
				templates: []
				//motivations: [],
				//tasks: []
			};
		},
		watch: {
			from(newVal) {
				this.to = newVal;
			},
			'entity.customer_id': {
				handler(n) {
					

					if (n === null || n == '' || n == 0) {
						
						this.resetCustomerSelection();
					} else {
						

						const c = this.rawCustomers.find((item) => {
							

							return item.customerNumber == n;
						});

						if (c) {
							

							this.entity.customer_group_id 	= c.customerGroup.customerGroupNumber;
							this.entity.vat_zone_id 		= c.vatZone.vatZoneNumber;
							this.entity.currency_id 		= c.currency;
							//this.entity.layout_id 			= c.layout;
							this.entity.terms_id 			= c.paymentTerms.paymentTermsNumber;
						}
					}
				}
			}
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'ContactSelectView': ContactSelectView,
			'TaskListView': TaskListView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					}
				];
			},
			_template() {
				var self = this;
				return this.templates.find(function (item) { return item.id == self.entity.template_id; });
			},
			_lines() {
				return this._template ? this._template.incl.split("\n") : [];
			},
			_numbers() {
				var r = [];

				for (var i = 0; i < this.staticNumbers.length; ++i) {
					r.push(this.staticNumbers[i]);
				}

				for (var i = 0; i < this.numbers.length; ++i) {
					r.push(this.numbers[i]);
				}

				// Add to entity
				var ent = this.entity;
				
				for (var i = 0; i < r.length; ++i) {
					if (!ent.customer.numbers.hasOwnProperty(r[i].name)) {
						ent.customer.numbers[r[i].label] = r[i].default;
					}
				}

				

				return r;
			},



			_customers() {
				var r = this.customers;

				// Search for customers here


				// Add NEW possibility
				const n = this.getInvoiceObj(this.value._embedded.contact);

				r.push({
					label: `${n.name} (Opret)`,
					value: 0
				});

				

				return r;
			},

			_customer_groups: {
				get() {
					return this.customer_groups;
				}
			},

			_currencies: {
				get() {
					return this.currencies;
				}
			},

			_layouts: {
				get() {
					return this.layouts;
				}
			},

			_terms: {
				get() {
					return this.terms;
				}
			},

			_vat_zones: {
				get() {
					return this.vat_zones;
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			submit: {
				type: Function,
				default: function (entity) { return true; }
			},
			value: {
				type: Object,
				default() {
					return merge({}, OrderModel.entity());
				}
			},
			lookup: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			resetCustomerSelection() {
				this.entity.customer_group_id 	= economics.customer_group_id;
				this.entity.vat_zone_id 		= economics.vat_zone_id;
				this.entity.currency_id 		= economics.currency_id;
				this.entity.layout_id 			= economics.layout_id;
				this.entity.terms_id 			= economics.terms_id;
			},
			getInvoiceObj(obj) {
				if (obj?._embedded?.invoice_contact) {
					return this.getInvoiceObj(obj._embedded.invoice_contact);
				} else {
					return obj;
				}
			},
			inclInput(val, line) {
				if (val) {
					this.entity.template.incl.push(line);
				} else {
					this.entity.template.incl.splice(this.entity.template.incl.indexOf(line), 1);
				}
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			async onAddButtonClick() {
				
				this.submit(this.entity);

				//
			},
			selectCustomer(obj) {
				
				this.numbers = [];

				for (var i = 0; i < obj.numbers.length; ++i) {
					this.numbers.push({
						name: 		obj.numbers[i].label,
						label: 		obj.numbers[i].label,
						default: 	obj.numbers[i].static ? obj.numbers[i].value : ''
					});
				}

				

				this.entity = merge(this.entity, {
					customer: {
						name: obj.name,
						address: {
							address: 	obj.address,
							zip: 		obj.zip,
							city: 		obj.city,
							country: 	obj.country
						},
						phone: obj.phone,
						email: obj.email,
						numbers: {
							vat:		obj.roles.business ? obj.roles.business.vat : '',
							ean:		obj.roles.business ? obj.roles.business.ean : ''
						}
					}
				});
			},
			onSaveAndInvoiceButtonClick() {
				
			}
		},
		mounted: async function() {
			
			

			var self = this;

			// Order here in "value", entity here
		

			
			

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/sales/orders/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/templates/orders/')
				.then(function (r) {
					self.templates = r.data._items;
				});

			




			this.currencies = (await this.axios.get('/integrations/economic/currencies/')).data.map((item) => { return {
				label: item.name,
				value: item.code
			}; });

			this.customer_groups = (await this.axios.get('/integrations/economic/groups/')).data.map((item) => { return {
				label: item.name,
				value: item.customerGroupNumber
			}; });

			this.terms = (await this.axios.get('/integrations/economic/terms/')).data.map((item) => { return {
				label: item.name,
				value: item.paymentTermsNumber
			}; });

			this.layouts = (await this.axios.get('/integrations/economic/layouts/')).data.map((item) => { return {
				label: item.name,
				value: item.layoutNumber
			}; });

			this.vat_zones = (await this.axios.get('/integrations/economic/vat-zones/')).data.map((item) => { return {
				label: item.name,
				value: item.vatZoneNumber
			}; });

			const pay = this.getInvoiceObj(this.value._embedded.contact);

			this.rawCustomers = (await this.axios.post('/integrations/economic/customers/find/', {
				phone: 		pay.phone
			})).data;

			this.customers = this.rawCustomers.map((item) => { return {
				label: `${item.customerNumber}, ${item.name}, ${item.address}, ${item.zip} ${item.city}, ${item.country}`,
				value: item.customerNumber
			}; });

	


			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
